import fetchClient from '@/api/api-client'

export const getAllCoupons = async () => {
  try {
    const result = await fetchClient.get(`/coupons`)
    // console.log("getAllCoupons - result", result)

    return result.data.data.response
  } catch (error) {
    throw error
  }
}

export const createCoupon = async data => {
  try {
    const payload = {
      data,
    }
    return await fetchClient.post(`/coupons`, payload)
  } catch (error) {
    throw error
  }
}

export const getCouponById = async id => {
  try {
    const result = await fetchClient.get(`/coupons/${id}`)
    // console.log("getCouponById - result", result)

    return result?.data?.data.response[0]
  } catch (error) {
    // console.log("getCouponById - error", error)
    throw error.response.data.msg
  }
}

export const getCouponByRefUserId = async id => {
  try {
    const res = await fetchClient.post(`/coupons/byrefuserid`, { id })

    return res.data.data.response
  } catch (error) {
    // console.log('getCouponByRefUserId - error', error)
    throw error
  }
}

export const updateCoupon = async (id, coupon) => {
  try {
    const res = await fetchClient.patch(`/coupons/${id}`, coupon)
    // console.log("updateCoupon - res", res)
    return res
  } catch (error) {
    throw error
  }
}

export const deleteCoupon = async id => {
  try {
    return await fetchClient.delete(`/coupons/${id}`)
  } catch (error) {
    throw error
  }
}

export const checkCoupon = async code => {
  try {
    const res = await fetchClient.post(`/coupons/check`, code)
    return res.data.data
  } catch (error) {
    throw error
  }
}

export const batchUpdateCoupons = async ({ couponIds, updateData }) => {
  try {
    const payload = { couponIds, updateData }
    const res = await fetchClient.put(`/coupons/batch-update`, payload)
    return res.data.data
  } catch (error) {
    throw error
  }
}

// export const getCouponByCode = async (filter) => {
//   try {
//     const res = await fetchClient.post(`/coupons/bycode`, filter)
//     //const res = await axios.post(`${BASEURL}/coupons/bycode`, filter)
//     return res.data.data[0]
//   } catch (error) {
//     throw error
//   }
// }
